<template>
  <div
    :class="[isHighlight ? 'intro' : 'text', textColor, listStyleClasses]"
    v-html="text"></div>
</template>

<script>
import { computed } from "vue";
import { useCustomValidator } from "../../compostables/useValidators";

export default {
  props: {
    color: {
      type: String,
      required: false,
      default: null,
      validator(value) {
        return useCustomValidator(["navy", "white"], value);
      },
    },
    isHighlight: {
      type: Boolean,
      required: false,
      default: false,
    },
    listStyle: {
      type: String,
      required: false,
      default: null,
      validator(value) {
        return ["arrow"].indexOf(value) !== -1;
      },
    },
    text: {
      type: String,
      required: false,
    },
  },

  setup(props) {
    const textColor = computed(() => {
      switch (props.color) {
        case "navy":
          return "child:text-navy navy";
          break;

        case "white":
          return "child:text-white white";
          break;

        default:
          return "child:text-default default";
          break;
      }
    });

    const listStyleClasses = computed(() => {
      return {
        "list-style list-style--arrows": props.listStyle === "arrow",
      };
    });

    return {
      listStyleClasses,
      textColor,
    };
  },
};
</script>

<style></style>
